export default "<h1>Page not found</h1>\n<p>The requested page could not be found! Please go to the <a routerLink=\"/\">Home page</a>.</p>"